export const DEFAULT_TOUCH_SLOP = 15;
export const MINIMAL_FLING_VELOCITY = 0.1;
